import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const cls = "rounded-xl bg-[#0B0F19] border-[#26334D] focus-visible:ring-[#FF3B6B]";
const inWeek = () => { const d = new Date(); d.setDate(d.getDate() + 7); return d.toLocaleDateString("en-CA"); };

export function DealsEditor({ deals, onChange }) {
  const set = (i, k, v) => onChange(deals.map((d, j) => (j === i ? { ...d, [k]: v } : d)));
  return (
    <div className="space-y-2 rounded-xl border border-[#FF3B6B]/30 p-3">
      <div className="flex items-center justify-between">
        <Label className="text-slate-300 text-sm">Limited-time deals</Label>
        <Button type="button" data-testid="biz-add-deal" variant="ghost" size="sm" onClick={() => onChange([...deals, { _key: crypto.randomUUID(), title: "", details: "", code: "", ends: inWeek() }])}>
          <Plus className="h-4 w-4 mr-1" /> Add deal
        </Button>
      </div>
      {deals.length === 0 && <p className="text-xs text-slate-500">Post a deal (e.g. "2-for-1 tickets") — it shows on your listing until it ends.</p>}
      {deals.map((d, i) => (
        <div key={d._key || d.id} className="grid sm:grid-cols-[1fr_1fr_auto_auto] gap-2">
          <Input data-testid={`biz-deal-title-${i}`} required maxLength={80} placeholder="Deal title" value={d.title} onChange={(e) => set(i, "title", e.target.value)} className={cls} />
          <Input data-testid={`biz-deal-details-${i}`} maxLength={300} placeholder="Details (optional)" value={d.details} onChange={(e) => set(i, "details", e.target.value)} className={cls} />
          <Input data-testid={`biz-deal-code-${i}`} maxLength={40} placeholder="Code" value={d.code} onChange={(e) => set(i, "code", e.target.value)} className={`${cls} sm:w-28`} />
          <div className="flex gap-2">
            <Input data-testid={`biz-deal-ends-${i}`} type="date" required value={d.ends} onChange={(e) => set(i, "ends", e.target.value)} className={`${cls} w-36`} />
            <Button type="button" variant="ghost" size="icon" onClick={() => onChange(deals.filter((_, j) => j !== i))}><Trash2 className="h-4 w-4" /></Button>
          </div>
        </div>
      ))}
    </div>
  );
}
